<template>
    <BaseDialog :close-on-mask="closeOnMask" @reject="onClose">
        <div class="skill-dialog u-dialog">
            <div class="dialog-content">
                <div class="u-btn close" @click="onClose"></div>

                <div class="side-layer" :class="'char-' + id">
                    <div class="char-img" :class="'char-' + id"></div>
                </div>
                <div class="panel-dialog">
                    <div class="skill-content">
                        <div class="skill-name">
                            <div class="name" :class="'skill-' + id"></div>
                            <div class="label-skill"></div>
                        </div>

                        <div class="skill-intro">
                            <simplebar class="scroll-area" data-simplebar-auto-hide="false">
                                <div class="context needLang hyz" v-html="skill_data[id - 1]"></div>
                            </simplebar>
                        </div>

                        <div class="skill-img">
                            <div class="gif-view">
                                <img :src="skill_img_url + id + '.gif'" alt="" srcset="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </BaseDialog>
</template>
<script>
import BaseDialog from '../BaseDialog.vue'

export default {
    name: 'SkillDialog',
    components: {
        BaseDialog,
    },
    props: {
        closeOnMask: {
            type: Boolean,
            default: true
        },
        id: {
            type: Number,
            default: 1,
        }
    },
    mounted(){     
    }, 
    data() {
        return {
            skill_img_url : 'https://web-resource.17m3.com/m3guo/202606/version-zz/skins/',
            skill_data : [
                '外部装备为8件物理/法术/生存装备时，获得以下效果<br>\
                冰霜妖气额外获得【15%最大生命值】的护盾<br>\
                释放后的友方玩家英雄增加15点护甲及10%物理/法术爆伤抗性，持续4秒，同时该单位攻击敌方玩家英雄时，还会降低其15点护甲及10%物理/法术爆伤抗性，持续4秒',

                '大招聚气时间缩短50%，位移期间无敌，<br>\
                外部装备为8件物理装备时，获得以下效果<br>\
                战场/关卡中，被动提升15%/50%所有攻击力，大招到达目的地后立即获得30%最大生命值的护盾，持续5秒<br>\
                关卡中，自身英雄全技能伤害提升700%<br>\
                【额外加成】普通攻击和所有技能对神圣护甲单位造成的伤害提升45%',

                '外部装备为8件法术装备时，获得以下效果<br>\
                震波命中敌方玩家英雄时，额外降低其15%法术爆伤抗性，持续5秒<br>\
                地刺和大招对处于共振状态下的敌方单位额外造成20%的伤害<br>\
                关卡中，震波和地刺伤害提升1300%，大招伤害提升600%',

                '外部装备为8件法术装备时，获得以下效果<br>\
                符*幻神咒的弹道速度提升50%<br>\
                星河无量释放时会触发一次星河陨落，对400范围内的敌方单位造成150点法术伤害，并降低被命中敌方玩家英雄25%法术爆伤抗性，持续3秒<br>\
                关卡中，星河陨落造成的伤害提升至28000，星河无量伤害提升1200%<br>\
                【额外加成】普通攻击和所有技能对神圣护甲单位造成的伤害提升45%'
            ],
        }
    },   
    methods: {
        onClose() {
            this.$emit('resolve', false)
        },
    }
}
</script>

<style lang="scss" scoped>
.skill-dialog{
    position: relative;
    width: 716px;
    height: 651px;
    margin-left: 60px;
    background-image: url(~@/assets/images/modal/bg-modal-skill.png);
}

.side-layer{
    position: absolute;
    left: -308px;
    top: 50%;
    transform: translateY(-50%);

    &.char-2{
        left: -430px;
    }

    &.char-3{
        left: -320px;
        top: 40%;
    }

    &.char-4{
        left: -280px;
        top: 45%;
    }

    .char-img{
        &.char-1{
            width: 846px;
            height: 759px;
            background-image: url(~@/assets/images/modal/c-1.png);
        }

        &.char-2{
            width: 904px;
            height: 758px;
            background-image: url(~@/assets/images/modal/c-2.png);
        }

        &.char-3{
            width: 808px;
            height: 767px;
            background-image: url(~@/assets/images/modal/c-3.png);
        }

        &.char-4{
            width: 791px;
            height: 726px;
            background-image: url(~@/assets/images/modal/c-4.png);
        }
    }
}

.skill-content{
    position: relative;
    width: 367px;
    margin-left: 295px;
    padding-top: 35px;
}

.skill-name{
    display: flex;
    align-items: center;
    margin-bottom: 30px;

    .label-skill{
        width: 113px;
        height: 41px;
        margin-left: 20px;
        background-image: url(~@/assets/images/modal/label-skill.png);
    }

    .name{
        &.skill-1{
            width: 200px;
            height: 55px;
            background-image: url(~@/assets/images/modal/skill-1.png);
        }

        &.skill-2{
            width: 197px;
            height: 54px;
            background-image: url(~@/assets/images/modal/skill-2.png);
        }

        &.skill-3{
            width: 122px;
            height: 55px;
            background-image: url(~@/assets/images/modal/skill-3.png);
        }

        &.skill-4{
            width: 197px;
            height: 54px;
            background-image: url(~@/assets/images/modal/skill-4.png);
        }
    }
}

.scroll-area{
    height: 209px;
}

.context{
    font-size: 24px;
    color: #f1ede6;
    line-height: 1.6;
    padding-right: 30px;
}

.gif-view{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 367px;
    height: 207px;
    margin-top: 20px;
    background-image: url(~@/assets/images/modal/img-wrapper_gif.png);

    img{
        width: 100%;
        height: 100%;
        mask: url(~@/assets/images/modal/img-wrapper_gif.png) no-repeat center;
    }
}

@include responseTo('desktop') {
    .context{
        font-size: 20px;
    }   
}

@include responseTo('phone') {
    .u-btn.close{
        right: auto;
        left: 50%;
        top: 105%;
        transform: translateX(-50%);
        width: 46px;
        height: 46px;
        background-image: url(~@/assets/images/modal/btn-modal-close_video.png);
    } 
}
</style>